"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const PeakAuthMeClient_1 = __importDefault(require("./clients/PeakAuthMeClient"));
const PeakAuthVerifyClient_1 = __importDefault(require("./clients/PeakAuthVerifyClient"));
const PeakAuthWithClient_1 = __importDefault(require("./clients/PeakAuthWithClient"));
const PeakAuthOAuthClient_1 = __importDefault(require("./clients/PeakAuthOAuthClient"));
const PeakAuthServicesClient_1 = __importDefault(require("./clients/PeakAuthServicesClient"));
const PeakAuthMetaClient_1 = __importDefault(require("./clients/PeakAuthMetaClient"));
const PeakAuthLogoutClient_1 = __importDefault(require("./clients/PeakAuthLogoutClient"));
const PeakAuthUsersClient_1 = __importDefault(require("./clients/PeakAuthUsersClient"));
const PeakAuthUserServicesClient_1 = __importDefault(require("./clients/PeakAuthUserServicesClient"));
const PeakAuthResetClient_1 = __importDefault(require("./clients/PeakAuthResetClient"));
const PeakAuthSignUpClient_1 = __importDefault(require("./clients/PeakAuthSignUpClient"));
const PeakAuthValidateClient_1 = __importDefault(require("./clients/PeakAuthValidateClient"));
const PeakAuthGroupsClient_1 = __importDefault(require("./clients/PeakAuthGroupsClient"));
const PeakAuthTenantClient_1 = __importDefault(require("./clients/PeakAuthTenantClient"));
const PeakAuthClientsClient_1 = __importDefault(require("./clients/PeakAuthClientsClient"));
const PeakAuthStoreClient_1 = __importDefault(require("./clients/PeakAuthStoreClient"));
const PeakAuthLicensesClient_1 = __importDefault(require("./clients/PeakAuthLicensesClient"));
class PeakAuthClients {
    constructor(client) {
        this.client = client;
        this.clients = new PeakAuthClientsClient_1.default(client);
        this.groups = new PeakAuthGroupsClient_1.default(client);
        this.licenses = new PeakAuthLicensesClient_1.default(client);
        this.logout = new PeakAuthLogoutClient_1.default(client);
        this.me = new PeakAuthMeClient_1.default(client);
        this.meta = new PeakAuthMetaClient_1.default(client);
        this.oauth = new PeakAuthOAuthClient_1.default(client);
        this.reset = new PeakAuthResetClient_1.default(client);
        this.services = new PeakAuthServicesClient_1.default(client);
        this.signup = new PeakAuthSignUpClient_1.default(client);
        this.store = new PeakAuthStoreClient_1.default(client);
        this.tenant = new PeakAuthTenantClient_1.default(client);
        this.users = new PeakAuthUsersClient_1.default(client);
        this.userServices = new PeakAuthUserServicesClient_1.default(client);
        this.validate = new PeakAuthValidateClient_1.default(client);
        this.verify = new PeakAuthVerifyClient_1.default(client);
        this.with = new PeakAuthWithClient_1.default(client);
    }
}
exports.default = PeakAuthClients;
